export default "__VITE_ASSET__DrbG0dzB__"